import { ensureExhaustive, exhaustiveReducer } from "halifax";
import { Initial } from "redmond";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { actions } from "../actions";
import {
  FETCH_PREMIUM_OFFERS_SHOP,
  SET_PREMIUM_OFFERS_SHOP_RESULTS,
} from "../actions/constants";
import { RequestState, RequestStateUtils } from "./requestState";

export * from "./requestState";

export interface IRooms {
  numberOfRooms: number;
}

export interface IPremiumCollectionOffersSearchState {
  premiumOffersShopCall: RequestState<
    IOfferAvailabilityRequest,
    Initial,
    unknown
  >;
  // TODO: CLUX-627 - add sort and filters
  //   sort: TODO;
  //   filters: TODO;
}

const initialState: IPremiumCollectionOffersSearchState = {
  premiumOffersShopCall: RequestStateUtils.notCalled(),
};

export const reducer = exhaustiveReducer(
  initialState,
  (
    state: IPremiumCollectionOffersSearchState,
    action: actions.PremiumCollectionOffersSearchActions
  ): IPremiumCollectionOffersSearchState => {
    switch (action.type) {
      case FETCH_PREMIUM_OFFERS_SHOP:
        return {
          ...state,
          premiumOffersShopCall: RequestStateUtils.inProgress(action.params),
        };
      case SET_PREMIUM_OFFERS_SHOP_RESULTS:
        return {
          ...state,
          premiumOffersShopCall: action.payload,
        };
      default:
        return ensureExhaustive(action);
    }
  }
);
